<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Template Actions</h5>
            </div>
            <div class="card">
                <DataTable :value="templateactionlist" v-model:selection="selectedProduct" :lazy="true"
                    :paginator="true" :rows="30" :totalRecords="totalRecords" :loading="loading" @page="onPage($event)"
                    class="p-datatable-users" data-key="td1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Template Actions</h5>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data Please wait... </template>
                    <Column header="Sr." headerStyle="width: 4%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column field="name" header="Action Name" headerStyle="width: 50%">
                        <template #body="{ data }">
                            <div class="p-text-capitalize">{{ data.td2 ? data.td2 : 'N/A' }}</div>
                        </template>
                    </Column>
                    <Column header="Unique Id" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <div> {{ data.td3 }}</div>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button label="Edit Event" class="p-button-link" @click="templateActionsRedirect(data)" />
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from '../../service/ApiService';
import router from '@/router';
import { useRoute } from 'vue-router';
export default {
    data() {
        return {
            templateactionlist: [],
            page_no: 0,
            totalRecords: 0,
            loading: false,
            showLoader: false,
            submitted: false,
            editheaderflag: 0,
            showloaderpage: false,
            localActionId: '',
            localClientId: '',
            localClientName: '',
            isCopyWhatsappSetting: false,
            selectedProduct: [],
        };
    },

    ApiService: null,

    created() {
        this.ApiService = new ApiService();
    },

    mounted() {
        const route = useRoute();
        this.routeParam = route.params.clientSubId;
        this.localClientName = localStorage.localClientName;
        this.loading = true;
        this.getTemplateActions();
        if (localStorage.localActionId) {
            this.localActionId = localStorage.localActionId;
        }
        if (localStorage.localClientId) {
            this.localClientId = localStorage.localClientId;
        }
    },

    watch: {
        localActionId(actionId) {
            localStorage.localActionId = actionId;
        },
        localClientId(clientId) {
            localStorage.localClientId = clientId;
        }
    },

    methods: {
        getTemplateActions(ev) {
            this.loading = true;
            this.ApiService.getTemplateActions(ev).then((data) => {
                if (data.status == 200) {
                    this.templateactionlist = data.data;
                    this.totalRecords = data.count;
                } else {
                    this.templateactionlist = '';
                    this.totalRecords = 0;
                }
                this.loading = false;
            });
        },

        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getTemplateActions({ page_no: event.page });
        },

        templateActionsRedirect(e) {
            router.push({
                name: "listclientTemplateEvent",
                // params: { actionId: e.td1 },
            });
            this.localActionId = e.td1;
            this.localClientId = this.routeParam;
        },
    },
};
</script>
<style scoped lang="scss">
.plan-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-free {
        background: #c8e6c9;
        color: #256029;
    }

    &.status-paid {
        background: #ffd8b2;
        color: #805b36;
    }
}

.plan-type-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-standard {
        background: #b3e5fc;
        color: #23547b;
    }

    &.status-premium {
        background: #eccfff;
        color: #694382;
    }
}
</style>
